import { render } from "./bookmark_folders.vue?vue&type=template&id=2f40d607"
import script from "./bookmark_folders.js?vue&type=script&lang=js"
export * from "./bookmark_folders.js?vue&type=script&lang=js"

import "./bookmark_folders.vue?vue&type=style&index=0&id=2f40d607&lang=scss"

import exportComponent from "/home/jojo/Documents/aspho-fe-pleromer/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__